<template>
    <PublicLayout :title="$t('frontend.treatments')">
        <div class="grid gap-8 grid-cols-1 md:grid-cols-2" :class="`lg:grid-cols-${gridCols}`">
            <div v-for="treatment in treatments" :key="treatment.id" class="flex flex-col">
		<div class="text-center text-md">
                    <h2 class="text-secondary line-clamp-2 h-[3rem] leading-snug overflow-hidden break-words"
                        :title="treatment.name">
                        {{ treatment.name }}
                    </h2>
                </div>
                <div>
                    <VideoBox
                        v-if="treatment.thumbnail_url"
                        :title="treatment.name"
                        :video-url="treatment.video_url"
                        :background-image="treatment.thumbnail_url"></VideoBox>
                </div>
            </div>
        </div>
    </PublicLayout>
</template>

<script setup>
import {computed} from 'vue';
import {VideoBox} from '@/Components/Media';
import PublicLayout from '@/Layouts/PublicLayout.vue';

const props = defineProps({
    treatments: {
        type: Array,
        required: true,
    },
});

const gridCols = computed(() => (props.treatments.length >= 3 ? 3 : 2));
</script>
